import moment from "moment";
// Registers moment's Polish locale (and, as a side effect of defineLocale, makes it moment's
// global default - matching the app's behaviour before i18n). English is compiled into moment's
// core, so it survives the moment-locales-webpack-plugin stripping in webpack.config.prod.js
// (localesToKeep: ["pl"]). Do NOT switch to "en-gb": it would be stripped in prod only.
import "moment/locale/pl";
import { getLocale } from "./index";
import { DISPLAY_DATE_FORMAT } from "./formats";

export * from "./formats";

const MOMENT_LOCALES = { pl: "pl", en: "en" };

// Per-instance locale, never moment.locale(...) globally - a global switch would leak into wire
// formats and into any other module that happens to format a date.
const localized = (value, locale) => moment(value).locale(MOMENT_LOCALES[locale] || "pl");

// No locale argument: DD.MM.YYYY is digits and separators only, identical in every language.
// Unparseable input is returned unchanged rather than as moment's "Invalid date" - this is a
// display helper, and callers such as lib/formatHelper.js relied on that graceful fallback.
export const formatDate = (value) => {
   const parsed = moment(value);
   return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : value;
};

// These DO take a locale - they render day names, which stay translated.
export const formatWeekday = (value, locale = getLocale()) =>
   localized(value, locale).format("dddd");

export const formatWeekdayMin = (value, locale = getLocale()) =>
   localized(value, locale).format("dd");

// "12.08.2026 (pn)" in PL, "12.08.2026 (Mo)" in EN - shared number pattern, translated day name.
export const formatDateWithWeekdayMin = (value, locale = getLocale()) =>
   `${formatDate(value)} (${formatWeekdayMin(value, locale)})`;
